/**
 * Defines ordered list of spectroscopy sections.
 * Used for page structure and navigation flow.
 */

export const spectroscopySections = [
  'landing',
  'what-is-spectroscopy',
  'what-all-instruments-have-in-common',
  'uv-vis',
  'fluorescence',
  'nmr',
  'epr',
  'ultrafast-ta'
];